






















/* eslint-disable class-methods-use-this */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import Component from 'vue-class-component';
import BaseComponent from '../BaseComponent';
import { v4 as uuidv4 } from 'uuid';

@Component({
  props: {
    label: String,
    tooltip: String,
    cols: { default: 8 },
    placeholder: {},
    value: {},
    min: Number,
    max: Number,
  },
})
export default class FormNumberInput extends BaseComponent {
  label!:string;

  value:any;

  cols!:number;

  placeholder!:any;

  min?:number;

  max?:number;

  id = uuidv4();

  get placeholderContent() {
    if (this.placeholder !== undefined) return `${this.placeholder}`;
    return '';
  }
  // model:any=null;
  get inputValue() {
    return this.value;
  }

  set inputValue(val) {
    this.$emit('input', parseFloat(val));
  }
}
